interface EmptySelectListProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
}

const EmptySelectList = ({ icon, title, description }: EmptySelectListProps) => {
  return (
    <div className="flex flex-col items-center justify-center space-y-2 p-4 text-[#CFCFCF]">
      {icon && <div className="text-4xl">{icon}</div>}
      <h3 className="mt-2 text-sm font-semibold">{title || "Vazio"}</h3>
      {description && <p className="mt-1 text-sm">{description}</p>}
    </div>
  );
};

export default EmptySelectList;
